module.exports = __webpack_public_path__ + "img/326666_66CBC9_C0B8AE_52B3B4-256px.746b7c07.png";